export const CATEGORY_NAVIGATION_SCROLL_OFFSET_VARIABLE =
  '--category-navigation-scroll-offset';
export const DETAIL_NAVIGATION_SCROLL_OFFSET_VARIABLE =
  '--detail-navigation-scroll-offset';
export const DESKTOP_PINNED_SCROLL_OFFSET = '94px';
export const DESKTOP_UNPINNED_SCROLL_OFFSET = '141px';
export const MOBILE_PINNED_SCROLL_OFFSET = '107px';
export const ZERO_SCROLL_OFFSET = '0px';

interface ResolveCategoryNavigationScrollOffsetInput {
  mode: 'responsive' | 'desktop' | 'mobile';
  showDesktop: boolean;
  showMobile: boolean;
  desktopInteractionEnabled: boolean;
  isDesktopPinned: boolean;
  isMobilePinned: boolean;
}

export function resolveCategoryNavigationScrollOffset({
  mode,
  showDesktop,
  showMobile,
  desktopInteractionEnabled,
  isDesktopPinned,
  isMobilePinned: _isMobilePinned,
}: ResolveCategoryNavigationScrollOffsetInput): string {
  const desktopShouldReserveOffset =
    showDesktop && (mode === 'desktop' || desktopInteractionEnabled);

  if (desktopShouldReserveOffset) {
    return isDesktopPinned
      ? DESKTOP_PINNED_SCROLL_OFFSET
      : DESKTOP_UNPINNED_SCROLL_OFFSET;
  }

  // Mobile navigation remains sticky at the viewport top, so it always
  // needs reserved jump-link offset whenever mobile nav is active.
  const mobileShouldReserveOffset = showMobile;

  if (mobileShouldReserveOffset) {
    return MOBILE_PINNED_SCROLL_OFFSET;
  }

  return ZERO_SCROLL_OFFSET;
}

export function resolveScrollOffsetVariableOwner(
  root: HTMLElement,
  doc: Document,
): HTMLElement {
  const rootNode = root.getRootNode();
  const shadowHost =
    rootNode instanceof ShadowRoot && rootNode.host instanceof HTMLElement
      ? rootNode.host
      : null;
  const appRootCandidate = root.closest('.mdc-app');
  const appRoot =
    appRootCandidate instanceof HTMLElement ? appRootCandidate : null;

  return appRoot ?? shadowHost ?? doc.documentElement;
}

interface ApplyScrollOffsetVariableInput {
  root: HTMLElement;
  doc: Document;
  variableName: string;
  value: string;
}

export function applyScrollOffsetVariable({
  root,
  doc,
  variableName,
  value,
}: ApplyScrollOffsetVariableInput): () => void {
  const variableOwner = resolveScrollOffsetVariableOwner(root, doc);

  variableOwner.style.setProperty(variableName, value);

  return () => {
    if (variableOwner.style.getPropertyValue(variableName) === value) {
      variableOwner.style.setProperty(variableName, ZERO_SCROLL_OFFSET);
    }
  };
}
